module.exports = __webpack_public_path__ + "img/lose.11c36939.png";